const utils = require('../../lib/utils');

module.exports = {
	config: {
		lastMileSelector:   '.tabs',
		open:               false,
		registerType:       'tab',
		registerSecret:     '',
		closable:           true,
		static: {
			title: 	'TAB TITLE NOT DEFINED',
			icon: 	''
		}
	},

	resourceData: {
		title:      '',
		icon:       ''
	},

	events: {
		close: {
			type: 'click',
			selector: 'button[data-field-type="close"]',
			action: function (event) {
				if(event.data.component.config.closable){
					event.preventDefault();
					event.stopImmediatePropagation();
					event.data.component.close();
				}
			}
		},

		activate: {
			type: 'click',
			action: function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.activate();
			}
		}
	},

	methods: {
		activate: function(forceHandler){
			if(this.refresh$().length > 0 && !this.$.hasClass('active')){
				this.$.addClass('active');
				getComponent(this.parentComponentIndex).focusTab(this.config.registerSecret);
				forceHandler = true;
				this.config.open = true;
			}
			if(!utils.isEmpty(forceHandler)){
				this.callHandler('onTabActivate');
			}
		},

		deactivate: function(){
			this.$.removeClass('active');
			this.callHandler('onTabDeactivate');
			this.config.open = false;
		},

		mark: function(type){
			if(type === 'validationFailed'){
				var $validationSymbol = $('<i class="fi fi-exclamation-circle statusSymbol validationFailedSymbol"></i>');
				var $oldValidationSymbol;
				if(($oldValidationSymbol = this.$.find('.validationFailedSymbol')).length > 0){
					$oldValidationSymbol.replaceWith($validationSymbol);
				}
				else {
					this.$.prepend($validationSymbol);
				}
			}
			else if(type == ''){
				var $statusSymbols;
				if(($statusSymbols = this.$.find('.statusSymbol')).length > 0){
					$statusSymbols.remove();
				}
			}
		},

		close: function(restoreActiveTab = false){
			var self = this;
			if(self.config.closable){
				self.closest('base_tabStrip_tabStrip', function(tabStripComponent){
					if(self.config.registerSecret !== undefined){
						tabStripComponent.removeTab(self.config.registerSecret, restoreActiveTab);
					}
				});
			}
		},

		remove: function(){
			this.callHandler('onTabRemove');
			this.destroy();
		}
	},

	hooks: {
		attach: function($element){
			if(this.config.open){
				$element.addClass('active');
			}
		}
	}
};